export const ADD_USER_DATA = "userInfoAdded";
export const ADD_DEMOGRAPHIC_DATA = "demographicsInfoAdded";
export const ADD_PRIMARY_INSURANCE_DATA = "primaryInsuranceDataAdded";
export const ADD_SECONDARY_INSURANCE_DATA = "secondaryInsuranceDataAdded";
export const ADD_ALLERGIES_DATA = "allergiesInfoAdded";
export const ADD_MEDICATIONS_DATA = "medicationsInfoAdded";
export const ADD_FAMILY_HISTORY = "familyHistoryAdded";
export const ADD_MEDICAL_HISTORY = "medicalHistoryAdded";
export const ADD_SURGICAL_HISTORY = "surgicalHistoryAdded";
export const ADD_SOCIAL_HISTORY = "socialHistoryAdded";
export const ADD_SHOE_SIZE = "shoeSizeAdded";
export const ADD_HIPPA_POLICY_DATA = "hippaPolicyDataAdded";
export const ADD_PRACTICE_POLICIES_DATA = "practicePoliciesDataAdded";
export const ADD_SURVEY_DATA = "surveysDataAdded";

export const REMOVE_USER_DATA = "userInfoRemoved";
